import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/common.json';
import es from './locales/es/common.json';
import fr from './locales/fr/common.json';
import ar from './locales/ar/common.json';
import pt from './locales/pt/common.json';
import zh from './locales/zh/common.json';

// Language resources
const resources = {
  en: { common: en },
  es: { common: es },
  fr: { common: fr },
  ar: { common: ar },
  pt: { common: pt },
  zh: { common: zh },
};

// Get saved language from localStorage or default to English
const getSavedLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('app_language');
    if (saved && ['en', 'es', 'fr', 'ar', 'pt', 'zh'].includes(saved)) {
      return saved;
    }
  }
  return 'en';
};

// Handle RTL for Arabic
const updateDocumentDirection = (lang: string) => {
  if (typeof document !== 'undefined') {
    if (lang === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = lang;
    }
  }
};

// Get initial language
const initialLanguage = getSavedLanguage();

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage, // Set initial language
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'app_language',
      caches: ['localStorage'],
    },
  });

// Update direction on language change
i18n.on('languageChanged', (lng) => {
  updateDocumentDirection(lng);
  localStorage.setItem('app_language', lng);
});

// Set initial direction
updateDocumentDirection(initialLanguage);

export default i18n;

